import auth from './modules/auth';
import subscription from './modules/subscription';
import app from './modules/app';
import video from './modules/video';
import insight from './modules/insight';
import question from './modules/question';
import campaign from './modules/campaign';
import splash from './modules/splash';
import tag from './modules/tag';
import settings from './modules/settings';
import plugins from './modules/plugins';
import videoPage from './modules/videoPage';
import organization from './modules/organization';
import planReducer from '../containers/Billing/reducer';
import { campaignLandingPageReducer } from './modules/campaignLandingPage';
import { headerReducer } from './modules/header';
import { campaignEditPageReducer } from './modules/campaigns';
import { mediaReducer } from './modules/media';
import { shareReducer } from './modules/share';
import { tagsReducer } from './modules/tags';
import { campaignListPageReducer } from './modules/campaignList';
import { pluginCreationReducer } from './modules/pluginCreation';
import { videoCompilationPageReducer } from './modules/videoCompilationPage';
import { contactsPageReducer } from './modules/contacts';

export default {
  auth,
  subscription,
  app,
  video,
  header: headerReducer,
  insight,
  question,
  campaign,
  campaignEdit: campaignEditPageReducer,
  campaignLanding: campaignLandingPageReducer,
  campaignList: campaignListPageReducer,
  splash,
  tag,
  settings,
  plugins,
  pluginCreation: pluginCreationReducer,
  videoPage,
  organization,
  plan: planReducer,
  media: mediaReducer,
  share: shareReducer,
  tags: tagsReducer,
  videoCompilation: videoCompilationPageReducer,
  contacts: contactsPageReducer
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js